/**
 * Private route file
 *
 * @package    src/shared
 * @author     DongTuring <dong@turing.com>
 * @copyright  2018 Turing Company
 * @license    Turing License
 * @version    2.0
 * @link       https://turing.ly
 */

import React from "react"
import { Route, Redirect } from "react-router-dom"
import { checkIfRoleCan } from "../constants/RoleActions"

/**
 * Function that redirects to the page if user is authenticated
 *
 * @author  DongTuring <dong@turing.com>
 * @param   component
 * @param   authenticated
 * @return
 */
export default function PrivateAdminRoute({
  component: Component,
  authenticated,
  checkRoleAction,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={props =>
        authenticated === 'true' ? (
          ((checkRoleAction && checkIfRoleCan(checkRoleAction)) || !checkRoleAction)
            ? <Component {...props} {...rest} />
            : <Redirect to="/admin" />
        ) : (
          <Redirect to={`/admin/login?redirect=${window.location.pathname}`} />
        )
      }
    />
  )
}
